/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * StudyIcon
 *
 * @file StudyIcon.jsx
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const StudyIcon = (props) => (
  <SvgIcon
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
     // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.6887 3.67486L15.5271 2.78954C14.8372 1.89088 13.742 1.31064 12.5115 1.313L3.92503 1.32942C1.85031
        1.33339 0.176987 2.99232 0.18755 5.03476L0.258585 18.7708C0.269147 20.8132 1.9596 22.4657 4.03431 22.4617L7.13336
        22.4558C7.53526 22.725 7.99624 22.9213 8.5 23.0221V25.626C8.5 26.7305 9.39543 27.626 10.5 27.626H20.5C21.6046 27.626
        22.5 26.7305 22.5 25.626V16.626C22.5 16.3781 22.4549 16.1408 22.3725 15.9218L23.7581 7.95318C24.108 5.94109 22.7338
        4.02562 20.6887 3.67486ZM8.5 16.626V20.3399L4.02338 20.3485C3.13422 20.3502 2.40974 19.642 2.40521 18.7667L2.33418
        5.03065C2.32965 4.15532 3.04679 3.44435 3.93595 3.44265L12.5225 3.42623C13.4116 3.42453 14.1361 4.13274 14.1406 5.00807L14.1904
        14.626H10.5C9.39543 14.626 8.5 15.5214 8.5 16.626ZM20.4188 14.626H16.337L16.2876 5.06391L20.3267 5.7567C21.2032 5.90702 21.7921
        6.72794 21.6422 7.59027L20.4188 14.626ZM11.0592 8.5665C11.5811 8.56428 12.0062 9.04749 12.0088 9.64579C12.0113 10.2441 11.5903
        10.7309 11.0684 10.7331L5.39852 10.7573C4.87662 10.7596 4.45148 10.2764 4.44894 9.67806C4.44641 9.07975 4.86743 8.59293 5.38933
        8.5907L11.0592 8.5665ZM10.6542 12.2718C11.2507 12.2692 11.7362 12.7522 11.7388 13.3505C11.7413 13.9488 11.2599 14.4359 10.6634
        14.4384L5.80351 14.4592C5.20706 14.4617 4.72148 13.9788 4.71894 13.3804C4.7164 12.7821 5.19787 12.2951 5.79432 12.2925L10.6542
        12.2718ZM20.5 16.626H10.5V25.626H20.5V16.626ZM18.5087 21.1078L13.7051 18.3711V23.8445L18.5087 21.1078Z"
      fill="currentColor"
    />
  </SvgIcon>
);
export default StudyIcon;
